import { errorMessage } from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Platform console: sandbox publish approval queue (#250). Approving unlocks live publish for the site. */
export class PlatformApproveQueueViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ requests: [], pendingOnly: true, status: "", tenant: "", busyId: null, error: null });
        this.client = client;
    }
    setPendingOnly(pendingOnly) {
        this.setState({ pendingOnly });
    }
    setStatus(status) {
        this.setState({ status });
    }
    setTenant(tenant) {
        this.setState({ tenant: tenant.trim().toLowerCase() });
    }
    /** Throws on failure so a LivePanel can surface it. */
    async load() {
        const { pendingOnly, status, tenant } = this.state;
        const params = {};
        if (pendingOnly)
            params.pending = true;
        else if (status)
            params.status = status;
        if (tenant)
            params.tenant = tenant;
        this.setState({ requests: await this.client.listPublishRequests(params) });
    }
    approve(id, note = "") {
        return this.review(id, () => this.client.approvePublishRequest(id, note), "published", "Approve failed");
    }
    reject(id, note = "") {
        return this.review(id, () => this.client.rejectPublishRequest(id, note), "rejected", "Reject failed");
    }
    /** Optimistic: row flips to the target status at once, rolled back if the call fails. */
    async review(id, act, next, fallback) {
        const before = this.state.requests;
        this.setState({
            busyId: id,
            error: null,
            requests: before.map((r) => (r.id === id ? { ...r, status: next } : r)),
        });
        try {
            await act();
        }
        catch (err) {
            this.setState({ busyId: null, requests: before, error: errorMessage(err, fallback) });
            return;
        }
        this.setState({ busyId: null });
        await this.load();
    }
}
//# sourceMappingURL=PlatformApproveQueueViewModel.js.map